module.exports = __webpack_public_path__ + "img/delete-note-icon.38f6956f.svg";